var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ small: _vm.isSmallScreen },attrs:{"id":"step-info"}},[_c('StepInfoHeader',{attrs:{"showHeaderHelperIcon":_vm.showHeaderHelperIcon}}),_c('div',[_vm._t("default")],2),_c('StepInfoFooter',{attrs:{"btnText":_vm.btnText,"classBtn":_vm.classBtn,"iconName":_vm.iconName,"showIcon":_vm.showIcon},on:{"click":_vm.handleClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }